export const getValueType = valueType => {
  const vt = (valueType && valueType.name && valueType.name.toLowerCase()) || 'number';
  return vt === 'time' ? 'number' : vt;
};

export const getChartType = valueType => (getValueType(valueType) === 'percentage' ? 'line' : 'bar');

export const palette = {
  line: ['#007EFF', '#FF6D00', '#8B16E3', '#FECB2E', '#0072B5', '#FF5733', '#23BFAA', '#4CAF50', '#FF6D00'],
  bar: ['#111111', '#E91019', '#777777', '#555555', '#D9D9D9', '#A4A4A4']
};
